import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/Store";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n.js";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import { AppWrapper } from "./AppWrapper.js";
// import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

// import { Buffer } from "buffer";
// window.Buffer = Buffer;
const root = ReactDOM.createRoot(document.getElementById("root"));
  // require("buffer")

root.render(

  //<React.StrictMode>
//   <GoogleReCaptchaProvidercallApilivepair
//   reCaptchaKey={"6LfqE3IsAAAAACpMn28fB59ZEPentM8ckYyKEBQK"}
// >
  <Provider store={store}>
    {/* <I18nextProvider i18n={i18n}> */}
      <TonConnectUIProvider manifestUrl="https://equlix.com/tonconnect-manifest.json">
          <I18nextProvider i18n={i18n}>
        <AppWrapper /> 
        
           </I18nextProvider>
      </TonConnectUIProvider>
 
  </Provider>
  // </GoogleReCaptchaProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("✅ SW registered:", registration);
      })
      .catch((error) => {
        console.log("❌ SW registration failed:", error);
      });
  });
}